import * as S from "./styled";

export const Loader = ({ loading }: { loading: boolean }) => {
  return (
    <S.Wrapper $visible={loading}>
      <S.Dot $i={1} />
      <S.Dot $i={2} />
      <S.Dot $i={3} />
      <S.Dot $i={4} />
    </S.Wrapper>
  );
};
